export default __webpack_public_path__ + "static/media/ARCO_BAHIA360.ac878156.pdf";